<template>
  <div class="monit-page">
    <div class="monit-main row justify-content-sb">
      <h3 v-if="mobile" class="page-title col-xs-12 col-sm-6 pt-2">
        Monitore sensores
      </h3>
      <toolbar
        v-if="mobile"
        class="col-xs-12 col-sm-6"
        type="sensors"
        :is-mobile="mobile"
        :filter-opt="filterOpt"
        :is-filtering="isFiltering"
        @filter-by="onFilterBy"
        :type-filtering="
          tab1.toLowerCase() === 'exibir todos' ? '' : tab1.toLowerCase()
        "
        @search="searchBy"
        @clear-search="onClearSearch"
        @reset="resetProp"
        :is-searching="isSearching"
        :filters="filters"
        :types-options="optionsLeft"
        :filter-tag="filterBy === 100 ? true : false"
        @type-change="changeTypeMobile"
        :not-exists="showErrorNotFound"
        :not-search="showErrorNotSearch"
      />

      <div v-if="loading" class="col-xs-12 center-xs mt-2">
        <spinner /> Aguarde...
      </div>

      <div
        v-if="showErrorNotSearch && !showErrorNotFound"
        class="EmptyRequest row center-xs mx-2 md-12 w-100 p-0 mt-3"
        style="text-align: left"
      >
        <img :src="searchIcon" class="empty" />
        <span>
          Não foi possível realizar a busca,
          <b-link @click="resetSearch"> clique aqui </b-link> para voltar a
          exibir os sensores.</span
        >
      </div>

      <div
        v-if="showErrorNotFound"
        class="
          EmptyRequest
          w-100
          p-0
          row
          center-xs center-md center-sm center-xs
          mt-3
        "
      >
        <img :src="emptyIcon" class="empty" />
        <span
          >Não há sensores para exibir. Para cadastrar um novo,
          <router-link to="/registers/devices">clique aqui</router-link></span
        >
      </div>

      <div class="container-cards">
        <div
          v-for="(item, index) in orderedList"
          :key="index"
          class="space-card"
        >
          <router-link
            :to="`/monitoring/sensors/${type ? type : ''}`"
            @click.native="
              () => {
                openDetailsDialog(item);
                selectedCard = index;
              }
            "
          >
            <div
              :class="`monitCard ${BGRF(item.RF_STAT, item.UPDATE)} ${
                selectedCard == index ? 'activeCard' : ''
              }`"
            >
              <div :class="`top ${setBG(item.STATUS)}`"></div>
              <div class="monit-name">
                {{ item.NAME }}
              </div>
              <div>
                <div>Modelo: {{item.MODEL}}</div>
                <span>
                  <swap-vertical-icon
                    v-if="item.STATUS == 'multi' && item.RF_STAT != 8"
                    title=""
                     style="font-size:15px;"
                  />
                  <arrow-up-icon
                    v-else-if="item.STATUS == 'high' && item.RF_STAT != 8"
                    title=""
                    style="font-size:15px;"
                  />
                  <arrow-down-icon
                    v-else-if="item.STATUS == 'low' && item.RF_STAT != 8"
                    title=""
                     style="font-size:15px;"
                  />
                </span>
                <span>{{ selectMeasureInfo(item).join(", ") }}</span>
              </div>

              <span class="info" v-if="item.RF_STAT != 8">
                {{ selectInfo(item).join(" ") }}
              </span>
              <div v-show="formatStatusDir(item)">
                <alert-icon title="" style="font-size: 0.9em" /><span>{{
                  formatStatusDir(item)
                }}</span>
              </div>

              <footer>
                <div id="date">{{ formatUpdate(item.UPDATE) }}</div>
                <div :class="`status ${setBG(item.STATUS)}`">
                  {{ selectInfoStatus(item.STATUS) }}
                </div>
              </footer>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="monit-helper" v-if="!mobile">
      <div class="container-helper">
        <header>
          <div class="header-group">
            <gauge-icon title="" customHeight="20px" />
            <div class="title-monit-helper">Monitoramento de sensores</div>
          </div>
        </header>

        <toolbar
          v-if="!mobile"
          class=""
          type="sensors"
          :is-mobile="mobile"
          :filterOpt="filterOpt"
          :is-filtering="isFiltering"
          :not-exists="showErrorNotFound"
          :not-search="showErrorNotSearch"
          @filter-by="onFilterBy"
          :type-filtering="
            tab1.toLowerCase() === 'exibir todos' ? '' : tab1.toLowerCase()
          "
          @search="searchBy"
          @clear-search="onClearSearch"
          :is-searching="isSearching"
        />
        <div class="filter-container mt-2">
          <div class="col-xs-12 filter-title">
            <h5>Filtro de exibição</h5>
            <span>{{ orderedList.length }}</span>
          </div>
          <div class="label ml-2 mr-2 mt-3" v-if="!mobile">
            Filtrar por modelo:
          </div>
          <div class="filter-model col-xs-12 ml-2 mr-2 mt-0 mb-0">
            <b-form-group v-if="!mobile" class="mb-0">
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="selectedCheckbox"
                :options="options"
                name="filters"
                button-variant="info"
                size="sm"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
          <div class="label ml-2 mr-2 mb-2 mt-3" v-if="!mobile">
            Filtrar por status:
          </div>
          <b-form-radio-group
            label="Filtro por comunicação: "
            v-model="selectedRadiusButton"
            buttons
            button-variant="light"
            size="md"
          >
            <div class="col-12">
              <b-form-radio name="Exibir todos" :value="null">
                Exibir todos</b-form-radio
              >
              <b-form-radio name="Na faixa" :value="'ok'">
                <!-- Na faixa -->
                Na faixa ({{ alerts["ok"].length }})
              </b-form-radio>
              <b-form-radio name="Acima" :value="'high'">
                <!-- Acima -->
                Acima ({{ alerts["high"].length }})
              </b-form-radio>
              <b-form-radio name="Abaixo" :value="'low'">
                <!-- Abaixo -->
                Abaixo ({{ alerts["low"].length }})
              </b-form-radio>
              <b-form-radio name="Problemas de comunicação" :value="'rf'">
                <!-- Problemas de comunicação -->
                Problemas de comunicação ({{ alerts["rf"].length }})
              </b-form-radio>
            </div>
          </b-form-radio-group>
        </div>
      </div>
    </div>
    <sensor-details
      :item="selected"
      :status-color="variant"
      :updated="updated"
      :variant="variant"
      :is-mobile="mobile"
      :show-details="showDetails"
      @close-details="closeDetails"
    />
  </div>
</template>


<script>
import { monitSignal, updateFormatter } from "@/pages/components/helpers";
import { monit } from "@/api";

import EventBus from "@/pages/components/eventBus";

export default {
  name: "monit-sensors",
  props: {
    mobile: Boolean,
  },
  created() {
    this.$emit(
      "title-change",
      this.mobile ? "M. de Sensores" : "Monitoramento de Sensores"
    );
    this.controller = new AbortController();
    this.selectedRadiusButton = null;
    this.monitLoop();
    if (!this.type) {
      this.tab1 = "EXIBIR TODOS";
    }
  },
  data() {
    return {
      showDetails: false,
      backendNow: null,
      loading: true,
      selected: {},
      selectedCard: null,
      filterBy: 100,
      missingResults: false,
      emptySensors: false,
      isSearching: false,
      isFiltering: false,
      filter: "",
      filterOpt: "",
      tab1: "",
      tab2: "",
      emptyIcon: require("../../../assets/icons/Empty.svg"),
      searchIcon: require("../../../assets/icons/search.svg"),
      type: null,
      optionsLeft: [],
      fullList: [],
      options: [],
      filters: [
        { value: "ok", text: "Na faixa" },
        { value: "high", text: "Acima" },
        { value: "low", text: "Abaixo" },
        { value: "rf", text: "Problemas de comunicação" },
      ],
      items: [],
      windPoints: {},
      controller: null,
      timeout: null,
      alerts: {
        ok: [],
        high: [],
        low: [],
        rf: [],
      },
      showErrorNotFound: false,
      showErrorNotSearch: false,
      checkboxList: [],
      selectedCheckbox: [],
      selectedRadiusButton: "",
    };
  },
  beforeDestroy() {
    this.controller.abort();
    clearTimeout(this.timeout);
  },
  watch: {
    selectedCheckbox() {
      if (!this.mobile) {
        this.isActive(this.items);
      }
    },
    selectedRadiusButton(v) {
      if (v != null) {
        this.onFilterBy(v);
      } else {
        this.showErrorNotSearch = false;
        this.onFilterBy(100);
      }
    },
    mobile(newValue, oldValue) {
      if (newValue) {
        this.showErrorNotSearch = false;
        this.showErrorNotFound = false;
        this.selectedRadiusButton = null;
        this.selectedCheckbox = [];
        this.filter = "";
      } else {
        this.resetSearch();
      }
    },
  },
  methods: {
    selectCard(item, index) {
      this.selectedCard = index;
      openDetailsDialog(item);
    },
    closeDetails() {
      this.showDetails = false;
      this.selected = {};
      this.selectedCard = null;
    },
    resetSearch() {
      this.selectedCheckbox = [];
      this.selectedRadiusButton = null;
      EventBus.cleanInputSearch();
      this.filter = "";
      this.isSearching = false;
      this.items = this.fullList;
      this.showErrorNotSearch = false;
      this.resetProp();
      this.resetDropdown();
      this.clearSearchInput();
    },

    onClearSearch() {
      this.filter = "";
      this.resetDropdown();
    },
    selectDropdownItem(option) {
      this.type = option;
      this.clearSearchInput();
    },
    changeTypeMobile(t) {
      this.type = t;
    },
    resetProp() {
      this.onFilterBy(100);
    },
    clearSearchInput() {
      if (!!this.$children[0] && this.$children[0].length > 0) {
        this.$children[0].clearText();
      }
      this.isSearching = false;
      this.items = this.fullList;
    },
    resetDropdown() {
      this.type = null;
      this.tab1 = "EXIBIR TODOS";
      this.title = "ALL";
      this.isSearching = false;
      this.showErrorNotSearch = false;
      this.items = this.fullList;
    },
    monitLoop() {
      monit
        .sensor(this.controller)
        .then((res) => {
          return res.json();
        })
        .then((ret) => {
          this.loadFilterModels(ret);
          let list = ret;
          this.fullList = list;
          if (this.isSearching && this.validFilter && list.length) {
            this.items = this.isSearch(list);
          } else {
            this.items = list;
          }
          if (this.loading) this.loading = false;
          if (
            Object.keys(this.selected).length &&
            this.selected.ID &&
            this.selected.NAME
          ) {
            this.selected =
              this.items.filter(
                (e) => e.ID == this.selected.ID && e.NAME == this.selected.NAME
              )[0] || this.selected;
          } /* else this.$refs.detailsSnsMonit.hide(); */
          return;
        })
        .then((_) => {
          if (!this.loading && !this.items.length && !this.showErrorNotSearch) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        })
        .catch((err) => {
          console.log(err);
          return err.name;
        })
        .then((ret) => {
          if (ret !== "AbortError") {
            this.timeout = setTimeout(this.monitLoop, 2000);
          }
        });
    },
    isActive(result) {
      let sensors = [];
      if (
        !this.mobile &&
        !!this.selectedCheckbox &&
        this.selectedCheckbox.length > 0
      ) {
        this.isFiltering = false;
        sensors = this.isSearchDropdown(result);
        if (result.length) {
        }
      } else if (
        !this.mobile &&
        !!this.selectedCheckbox &&
        !this.selectedCheckbox.length
      ) {
        this.tab1 = "EXIBIR TODOS";
        this.title = "ALL";
        this.isFiltering = false;
        sensors = this.fullList;
      } else if (!this.mobile) {
        this.selectedRadiusButton = null;
        this.selectedCheckbox = [];
        this.tab1 = "EXIBIR TODOS";
        this.title = "ALL";
        this.isFiltering = false;
        sensors = this.fullList;
      } else if (this.mobile && this.type) {
        this.tab1 = this.type;
        if (result.length) {
          sensors = this.isSearchDropdown(result);
        }
      } else if (this.mobile && !this.type) {
        this.showErrorNotSearch = false;
        this.selectedRadiusButton = null;
        this.selectedCheckbox = [];
        this.tab1 = "EXIBIR TODOS";
        this.title = "ALL";
        this.isFiltering = false;
        sensors = this.fullList;
      }

      return sensors;
    },
    isSearchDropdown(result) {
      if (this.mobile) {
        let filter;
        filter = result.filter((item) => item.MODEL == this.type);
        if (filter.length) {
          this.showErrorNotSearch = false;
          return filter.sort((a, b) => a.ID - b.ID);
        } else {
          this.showErrorNotSearch = true;
          return [];
        }
      } else {
        let results = [];
        for (let checkbox of this.selectedCheckbox) {
          let filter = result.filter((item) => item.MODEL == checkbox);
          results.push(...filter);
        }
        if (results.length) {
          this.showErrorNotSearch = false;
          return results.sort((a, b) => a.ID - b.ID);
        } else {
          this.showErrorNotSearch = true;
          return [];
        }
      }
    },
    isSearch(result) {
      let filter;
      filter = result.filter((item) => {
        if (item.MODEL.indexOf(this.filter) > -1) {
          return true;
        } else if (item.DIR.indexOf(this.filter) > -1) {
          return true;
        } else if (item.INTERFACE && item.INTERFACE.indexOf(this.filter) > -1) {
          return true;
        }
        return item.NAME.indexOf(this.filter) > -1;
      });
      if (filter.length) {
        this.showErrorNotSearch = false;
        return filter;
      } else {
        this.showErrorNotSearch = true;
        return [];
      }
    },
    formatUpdate(update) {
      return updateFormatter(update);
    },
    setBG(status) {
      switch (status) {
        case "rf":
          return "bg-rf";
        case "low":
          return "bg-red";
        case "multi":
          return "bg-orange";
        case "high":
          return "bg-yellow";
        case "ok":
          return "bg-3v3";
        default:
          return "bg-grey";
      }
    },
    BGRF(stat, update) {
      //comunição
      switch (stat) {
        case 0:
          return "";
        case 7:
          return "";
        case 8:
          return "bg-red-body";
        case 9:
          return "bg-black-body";
        default:
          return "";
      }
    },
    formatStatusDir(item) {
      switch (item.RF_STAT) {
        case 8:
          return ` O DIR ${item.DIR} está sem comunicar.`;
        case 9:
          return ` O DIR ${item.DIR} está sem comunicar.`;
        default:
          return;
      }
    },
    selectInfoStatus(status) {
      switch (status) {
        case "rf":
          return "bg-rf";
        case "low":
          return "ABAIXO";
        case "multi":
          return "ACIMA/ABAIXO";
        case "high":
          return "ACIMA";
        case "ok":
          return "NA FAIXA";
        default:
          return "INDEFINIDO";
      }
    },
    searchBy(name) {
      // if (!this.selectedRadiusButton) {
      //   this.isSearching = !!name.split(" ").join("");
      // }
      this.isSearching = !!name.split(" ").join("");
      this.filter = name.toUpperCase();
    },
    clearSearch() {
      if (!!this.$children[0] && this.$children[0].length > 0) {
        this.$children[0].clearText();
      }
      this.isSearching = false;
      this.missingResults = false;
    },
    onFilterBy(value) {
      // if (value == 100) this.clearSearch();
      this.isFiltering = value != 100;
      if (value.text) {
        this.filterOpt = value.text;
      }
      this.filterBy = value;
    },
    openDetailsDialog(item) {
      this.selected = item;
      this.showDetails = true;
    },
    selectMeasureInfo(item) {
      let { MEASURES } = item;
      let below = 0;
      let above = 0;
      let measure = "";
      for (let i = 0; i < MEASURES.length; i++) {
        if (MEASURES[i].STATUS != "ok" && MEASURES[i].RANGE) {
          if (MEASURES[i].STATUS == "low") {
            below++;
            measure = `${MEASURES[i].TYPE}`;
          } else if (MEASURES[i].STATUS == "high") {
            above++;
            measure = `${MEASURES[i].TYPE}`;
          }
        }
      }
      let info = [];
      if (above) {
        if (above == 1 && !below) info.push(measure);
        else info.push(`${above} acima`);
      }
      if (below) {
        if (below == 1 && !above) info.push(measure);
        else info.push(`${below} abaixo`);
      }
      return info;
    },
    selectInfo(item) {
      //as três primeiras medições para dispor no card
      let info = [];
      let m = "";
      if (item.hasOwnProperty("MEASURES")) {
        let measures = item.MEASURES;
        for (let i = 0; i <= 3; i++) {
          if (measures[i]) {
            m = i < 3 ? `${measures[i].VALUE}${measures[i].UNIT}` : " +";
            info.push(m);
          }
        }
      } else {
        info.push("");
      }
      return info;
    },
    loadFilterModels(ret) {
      let array1 = [];
      let op = [];
      this.loading = true;

      ret.forEach((e) => {
        op.push({ MODEL: e.MODEL });
        return op;
      });
      array1 = [...op];
      // Verifica se já existe os valores no this.optionsLeft
      if (
        array1.length === this.optionsLeft.length &&
        array1.every((value, index) => value === this.optionsLeft[index])
      ) {
        return;
      }
      // Caso não exista irá adicionar um novo valor
      else {
        let formatedOptions = [];
        array1.forEach((e, i) => {
          let alreadySelected = formatedOptions.findIndex(
            (x) => x.value === e.MODEL
          );
          if (alreadySelected >= 0) {
            let x = formatedOptions.filter((f) => f !== e.MODEL);
          } else {
            formatedOptions.push({ text: e.MODEL, value: e.MODEL });
          }
        });

        this.options = formatedOptions.sort((a, b) => {
          if (a.text < b.text) {
            return -1;
          } else if (a.text > b.text) {
            return 1;
          }
          return 0;
        });
        this.optionsLeft = [...array1];
      }
      this.loading = false;
    },
  },
  computed: {
    updated() {
      return Object.keys(this.selected).length && this.selected.UPDATE
        ? this.formatUpdate(this.selected.UPDATE)
        : "";
    },
    variant() {
      return Object.keys(this.selected).length
        ? this.setBG(this.selected.STATUS).split("-")[1]
        : "grey";
    },
    validFilter() {
      return !!this.filter.split(" ").join("");
    },
    orderedList() {
      let filter = this.filterBy;
      let result = this.items;

      if (result.length > 0) {
        result = this.isActive(result);
      }

      this.alerts["ok"] = result.filter((e) => e.STATUS == "ok");
      this.alerts["high"] = result.filter(
        (e) =>
          e.STATUS == "high" ||
          (e.STATUS == "multi" && e.MEASURES.filter((i) => i.STATUS == "high"))
      );
      this.alerts["low"] = result.filter(
        (e) =>
          e.STATUS == "low" ||
          (e.STATUS == "multi" && e.MEASURES.filter((i) => i.STATUS == "low"))
      );
      this.alerts["rf"] = result.filter((e) => this.BGRF(e.RF_STAT) != 0);

      if (
        this.isSearching &&
        this.validFilter &&
        result.length &&
        this.selectedRadiusButton == null
      ) {
        result = this.isSearch(result);
        this.alerts["ok"] = result.filter((e) => e.STATUS == "ok");
        this.alerts["high"] = result.filter(
          (e) =>
            e.STATUS == "high" ||
            (e.STATUS == "multi" &&
              e.MEASURES.filter((i) => i.STATUS == "high"))
        );
        this.alerts["low"] = result.filter(
          (e) =>
            e.STATUS == "low" ||
            (e.STATUS == "multi" && e.MEASURES.filter((i) => i.STATUS == "low"))
        );
        this.alerts["rf"] = result.filter((e) => this.BGRF(e.RF_STAT) != 0);
      }
      if (
        this.isSearching &&
        this.validFilter &&
        this.selectedRadiusButton !== null
      ) {
        result = this.isSearch(result);
        this.alerts["ok"] = result.filter((e) => e.STATUS == "ok");
        this.alerts["high"] = result.filter(
          (e) =>
            e.STATUS == "high" ||
            (e.STATUS == "multi" &&
              e.MEASURES.filter((i) => i.STATUS == "high"))
        );
        this.alerts["low"] = result.filter(
          (e) =>
            e.STATUS == "low" ||
            (e.STATUS == "multi" && e.MEASURES.filter((i) => i.STATUS == "low"))
        );
        this.alerts["rf"] = result.filter((e) => this.BGRF(e.RF_STAT) != 0);
        if (filter != 100) {
          if (this.mobile) {
            result = this.alerts[filter.value];
            try {
              if (!result.length) {
                this.showErrorNotSearch = true;
              } else {
                this.showErrorNotSearch = false;
              }
            } catch (error) {
              console.error("Result -> error :", error);
            }
          } else {
            result = this.isSearch(this.alerts[filter]);
            if (!result.length) {
              this.showErrorNotSearch = true;
            } else {
              this.showErrorNotSearch = false;
            }
          }
        }
      }
      // Estiver filtrando por comunicação
      else if (filter != 100) {
        if (this.mobile) {
          result = this.alerts[filter.value];
          try {
            if (!result.length) {
              this.showErrorNotSearch = true;
            } else {
              this.showErrorNotSearch = false;
            }
          } catch (error) {
            console.error("Result -> error :", error);
          }
        } else {
          result = this.isSearch(this.alerts[filter]);
          if (!result.length) {
            this.showErrorNotSearch = true;
          } else {
            this.showErrorNotSearch = false;
          }
        }
      }

      return result;
    },
  },
};
</script>

<style scoped>
.measure-info {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.EmptyRequest {
  width: 100%;
  padding: 10px;
  color: Black;
  font-size: 1.1rem;
  text-align: center;
}
.my-class {
  padding: 0;
}
.monitCard{
  min-height: 159px;
}

.filter-model {
  max-height: 180px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
